// @flow
import React from 'react';
import { TableRow, TableCell } from '@mui/material';
import { percentColors3 } from '../../../lib/utils';
import { compose } from 'recompose';
import { withTranslation } from 'react-i18next';

type Props = {
    title: string,
    latestVersion: number,
    totalSend: number,
    totalEmployees: number,
    totalCompleted: number,
    logo: string,
};

const StatisticsRowInspection = (props: Props, context: Object) => {
    let {
        title,
        latestVersion,
        totalSend,
        totalEmployees,
        totalCompleted,
        allOk,
        logo,
        handleRowClick,
        t,
        ...childProps
    } = props;
    let toolTipText;

    logo === '/assets/images/cumela-logo.png'
        ? (toolTipText = 'Cumela inspectie')
        : logo === '/assets/images/vvw-admin-logo.svg'
        ? (toolTipText = 'Veilig Vakwerk inspectie')
        : logo === '/assets/images/aangepast.svg'
        ? (toolTipText = 'Aangepaste inspectie')
        : (toolTipText = 'Eigen inspectie');

    return (
        <TableRow
            {...childProps}
            className="selectable"
            onClick={handleRowClick}
        >
            <TableCell style={{ width: '20px' }}>
                <div className={'tooltip'}>
                    <span
                        className={'tooltiptext'}
                        style={
                            toolTipText === 'Cumela inspectie'
                                ? { top: '-10px', left: '65px' }
                                : toolTipText === 'Veilig Vakwerk inspectie'
                                ? { top: '-10px', left: '50px' }
                                : toolTipText === 'Aangepaste inspectie'
                                ? { top: '-10px', left: '55px' }
                                : { top: '-10px', left: '70px' }
                        }
                    >
                        {toolTipText}
                    </span>
                    <img height="20" width="20" src={logo} alt="logo" />
                </div>
            </TableCell>
            <TableCell style={{ width: '40%', wordBreak: 'break-all' }}>
                {title || '-'}
            </TableCell>
            <TableCell style={{ width: '20%' }}>{latestVersion}</TableCell>
            <TableCell style={{ width: '20%' }}>{totalSend}</TableCell>
            {/* <TableCell style={{ width: '20%' }}>{totalEmployees}</TableCell> */}
            <TableCell style={{ width: '10%' }}>
                {' '}
                <div
                    className={'tooltip'}
                    style={{ position: 'relative', display: 'inline-block' }}
                >
                    <span className={'tooltiptext'} style={{ left: '-50px' }}>
                        {totalCompleted +
                            t(' of ') +
                            totalEmployees +
                            ' ' +
                            t(
                                'employees have completed the workplace inspection'
                            )}
                    </span>
                    <div
                        className={'border-text'}
                        style={{
                            backgroundColor: getColorForPercentage(totalCompleted / totalEmployees, allOk),
                            borderColor: getColorForPercentage(totalCompleted / totalEmployees, allOk),
                            width: '60px',
                        }}
                    >
                        {totalCompleted + '/' + totalEmployees}
                    </div>
                </div>
            </TableCell>
        </TableRow>
    );
};

var percentColors = percentColors3;

var getColorForPercentage = function (pct, allOk) {
    let color = percentColors[1];

    if (pct === 0) {
        color = percentColors[0];
    }

    if (pct === 1 && allOk) {
        color = percentColors[2];
    }

    return 'rgba(' + [color.r, color.g, color.b].join(',') + ', 1)';
};

export default compose(withTranslation())(StatisticsRowInspection);
